export default "__VITE_ASSET__CQZ7bi5S__"